module.exports = __webpack_public_path__ + "static/img/gzzShade5.3acf738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzzShade5.png
// module id = 0jka
// module chunks = 2